module.exports = __webpack_public_path__ + "static/media/ncqa-health-plan-accredited.1c6b7460.jpg";